module.exports = __webpack_public_path__ + "img/PolyU-logo-white.518ffb1b.png";